"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _coreInventoryAdjust = _interopRequireDefault(require("../../coreProduct/coreInventoryAdjust"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
var _default = exports.default = {
  name: 'PointsProductInventoryAdjust',
  components: {
    inventoryAdjust: _coreInventoryAdjust.default
  }
};